// extracted by mini-css-extract-plugin
export default {"SearchModel":"search-model_SearchModel__oTYWr"};